<div class="main-container">
    <canvas class="background-canvas" #canvas></canvas>
    <div class="background-image" #backgroundImage></div>
    <div class="main">
        <div class="content">
            <ng-content></ng-content>
            <main-footer></main-footer>
        </div>
    </div>
</div>